import React from 'react';
import {
  EditableArea,
  Notification,
  Message,
  DataDefinitionList
} from '../../web.common';
import { sentenceCase } from 'change-case';
import { getApiErrorMessage } from '../../common/utils';

class EditEntity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      loadedData: null,
      asNew: false
    };

    this.save = this.save.bind(this);
  }

  async componentDidMount() {
    const { loadData, language } = this.props;
    try {
      const loadedData = await loadData();
      this.setState({ loadedData, isLoading: false });
    }
    catch (error) {
      const apiResponse = getApiErrorMessage(error, language);

      this.setState({
        isLoading: false,
        failedLoading: true,
        apiResponse
      });
    }
  }

  async onValidationError({ validateForm }) {
    const {
      onValidationError: passedOnValidationError,
      showValidationErrors
    } = this.props;


    const validationErrors = await validateForm();
    if (showValidationErrors) {
      const fieldsWithError = Object.keys(validationErrors).map(x => sentenceCase(x)).join(', ');
      this.setState({
        apiResponse: new Message('error', `Unable to save. Check fields: ${fieldsWithError}`)
      });
    }

    if (passedOnValidationError) {
      passedOnValidationError(validationErrors);
    }
  }

  save(receivedProps) {
    this.setState({ isLoading: true }, async () => {
      const {
        language,
        editData,
        entity,
        onSaveCompleted,
        goToNew
      } = this.props;

      const { loadedData, asNew } = this.state;

      let updatedData = null;
      let apiResponse;

      try {
        updatedData = await editData(loadedData, receivedProps.values, asNew);
        const message = asNew ? `${entity} stored as new successfully` : `${entity} updated successfully`;
        apiResponse = new Message('success', message);
        if (asNew && goToNew) {
          this.setState({ asNew: false }, () => goToNew(updatedData));
        }
      }
      catch (error) {
        console.error(`error while saving: ${error}`);
        apiResponse = getApiErrorMessage(error, language);

        this.setState({
          isLoading: false,
          apiResponse
        });

        return;
      }

      this.setState({
        isLoading: false,
        loadedData: updatedData,
        saveError: null,
        apiResponse
      });

      receivedProps.toggleAreaEditMode();

      if (onSaveCompleted) {
        onSaveCompleted();
      }
    });
  }

  render() {
    const { isLoading, loadedData, apiResponse, failedLoading, asNew } = this.state;

    const { entity, validation, getFormData, children, titleContent, saveAsNew } = this.props;

    const formData = getFormData(loadedData);

    return (
      <React.Fragment>
        <Notification newMessage={apiResponse} />

        {
          titleContent !== null && titleContent !== undefined ? titleContent : <h2>{entity}</h2>
        }

        {
           failedLoading ? '' : (
             <EditableArea
               ariaEditorName={`${entity}-edit`}
               onSubmit={receivedProps => this.save(receivedProps)}
               isLoading={isLoading}
               savingText='Updating...'
               displayButtonLabels
               validationSchema={validation}
               useFormikProps={false}
               onValidationError={formikProps => this.onValidationError(formikProps)}
               initialValues={formData}
             >
               {({ isEditMode, formikProps }) => (
                 <React.Fragment>
                   {children(isEditMode, formData, formikProps, loadedData)}
                   {
                     isEditMode && saveAsNew
                       ? (
                         <section className='panel active'>
                           <DataDefinitionList
                             classNames={['border-0', 'detail-page-list']}
                             listData={[{
                               'Save as new':
                           <span
                             style={{
                               textDecoration: 'underline',
                               cursor: 'pointer'
                             }}
                             onClick={() => this.setState({ asNew: !asNew })}
                           >
                             {asNew ? 'yes' : 'no' }
                           </span>
                             }]}
                           />
                         </section>
                       )
                       : ''
                   }
                 </React.Fragment>
               )}

             </EditableArea>
           )
        }
      </React.Fragment>
    );
  }
}

export default EditEntity;